// rootReducer.js
import authReducer from "./Reducers/authReducer"; // Default import
import bannerReducer from "./Reducers/bannerReducer";
import categoryReducer from "./Reducers/categoryReducer";
import chatReducer from "./Reducers/chatReducer";
import dashboardIndexReducer from "./Reducers/dashboardIndexReducer";
import ordersReducer from "./Reducers/ordersReducers";
import paymentReducer from "./Reducers/paymentReducer";
import productReducer from "./Reducers/productReducer";
import sellerReducer from "./Reducers/sellerReducer";
import subscriptionReducer from "./Reducers/subscrptionReducer";
import videoReducer from "./Reducers/videoReducer";

const rootReducer = {
    auth: authReducer,
    category : categoryReducer,
    product : productReducer,
    seller : sellerReducer,
    chat : chatReducer,
    order: ordersReducer,
    payment : paymentReducer,
    dashboardIndex : dashboardIndexReducer,
    banner : bannerReducer,
    subscription: subscriptionReducer,
    video: videoReducer
};

export default rootReducer;
